import angular from "angular";
import { moduleName as recordModule } from "../../records";
import { vsModuleName as lookupModuleName } from "../../records/lookup/module";
import { contractConfigurationConfig } from "./contract";
import { contractCostConfigurationConfig } from "./contractCost";
import { TypeOfAgreementConfig } from "./typeOfAgreement";
import { PerformanceGuaranteeConfig } from "./performanceGuaranteeType";
import { FeeStructureConfig } from "./feeStructureType";
import { CostTypeConfig } from "./costType";
import { configureLookupManagement } from "../../records/lookup/lookupManagement/config";
import {
  vsLookupManagementServiceName,
  vsLookupManagementServiceProviderName,
} from "./lookupManagement";
import { ContractMachineManufacturer } from "./contractMachineManufacturer";

export const vsModuleName = "SlotTrak.Contract.Configuration";

const module = angular
  .module(vsModuleName, [recordModule, lookupModuleName])
  .config(contractConfigurationConfig)
  .config(contractCostConfigurationConfig)
  .config(TypeOfAgreementConfig)
  .config(PerformanceGuaranteeConfig)
  .config(FeeStructureConfig)
  .config(CostTypeConfig)
  .config(ContractMachineManufacturer);

configureLookupManagement(module, {
  baseStateSref: "main.contract.lookups",
  lookupManagementServiceName: vsLookupManagementServiceName,
  lookupManagementServiceProviderName: vsLookupManagementServiceProviderName,
});
